import React, { createContext, useContext, useState } from "react";

// Single shared "is the cart panel open" state so Header and BottomNav both
// control ONE <Cart> instance instead of each mounting their own — two mounted
// Cart components each ran their own useEffect(() => checkLogin/getCart, [data]),
// doubling every /getCart network call on every cart mutation.
const CartUIContext = createContext(null);

export function CartUIProvider({ children }) {
  const [cartOpen, setCartOpen] = useState(false);
  const openCart = () => setCartOpen(true);
  const closeCart = () => setCartOpen(false);

  return (
    <CartUIContext.Provider value={{ cartOpen, openCart, closeCart }}>
      {children}
    </CartUIContext.Provider>
  );
}

export function useCartUI() {
  const ctx = useContext(CartUIContext);
  if (!ctx) throw new Error("useCartUI must be used within a CartUIProvider");
  return ctx;
}
